export default __webpack_public_path__ + "static/media/11.d25cb28f.png";